<template>
    <div class="d-flex" :class="($vuetify.breakpoint.mdAndUp) ? 'flex-row' : 'flex-column'">
        <slot name="dialogos" />
        <v-card v-if="$vuetify.breakpoint.mdAndUp" max-width="50%" width="50%" flat color="grey darken-2"
            class="d-flex rounded-0">
            <v-img :src="imagen"
                style="position: sticky; top: 0; height: 100vh; object-fit: cover; width: auto" />
        </v-card>
        <v-card :max-width="($vuetify.breakpoint.smAndDown) ? '100%' : '50%'" width="100%"
            class="custom-card justify-center" flat>
            <v-card-text v-if="!$vuetify.breakpoint.mdAndUp || !enCarrousel"
                class="d-flex font-weight-regular justify-center primary--text text-h5 mt-5">
                {{ titulo }}
            </v-card-text>
            <v-card flat v-if="enCarrousel" width="98%">
                <v-card-text v-if="$vuetify.breakpoint.mdAndUp" class="d-flex justify-center mt-5 mb-5">
                    <v-img max-width="275px" src="@/assets/Logo-bt-07.png" contain />
                </v-card-text>
                <v-card-text class="pa-0 d-flex justify-center font-weight-bold text-h6 primary--text my-2">
                    ¿Qué necesitás?
                </v-card-text>
                <v-card-text class="d-flex justify-center">
                    <CarouselCard style="scale: 0.98;" :items="itemsCarrousel[currentIndex]"
                        class="d-flex flex-column justify-center align-center" />
                </v-card-text>
            </v-card>
            <slot v-else name="form-final" />
            <v-card-actions class="d-flex justify-space-between align-center"
                :class="($vuetify.breakpoint.mdAndUp) ? 'custom-card-actions' : 'custom-card-actions-middle'">
                <v-btn @click="$emit('atras')" outlined color="secondary" elevation="0" class="pa-5">
                    <v-icon class="mr-2">mdi-chevron-left</v-icon>
                    ATRAS
                </v-btn>
                <v-btn v-if="enCarrousel" @click="$emit('siguiente')" class="pa-5" color="primary" elevation="0">
                    <v-icon class="mr-2">mdi-chevron-right</v-icon>
                    SIGUIENTE
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import CarouselCard from '@/components/cards/CarouselCard.vue';

export default {
    name: 'LayoutSubsidio',
    components: {
        CarouselCard,
    },
    props: {
        imagen: {
            type: String,
            required: true,
        },
        titulo: {
            type: String,
            required: true,
        },
        itemsCarrousel: {
            type: Array,
            required: true,
        },
        currentIndex: {
            type: Number,
            required: true,
        },
    },
    computed: {
        enCarrousel() {
            return this.currentIndex < this.itemsCarrousel.length;
        },
    },
};
</script>

<style scoped>
.custom-card {
    position: relative;
    height: 100%;
    cursor: default;
    padding-bottom: 80px;
    /* Espacio suficiente para que el contenido no quede tapado por las acciones fixed */
}

.custom-card-actions {
    position: fixed;
    bottom: 0;
    left: 50%;
    right: 0;
    height: 65px;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    background: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
}

.custom-card-actions-middle {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 65px;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    background: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
}
</style>
